export default __webpack_public_path__ + "static/media/exclamation-yellow.315e16e8.svg";